



import * as React from "react";
import { Link, useLocation } from "react-router-dom";

import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Home as HomeIcon,
  People as PeopleIcon,
  Store as StoreIcon,
  Business as BusinessIcon,
  LocalShipping as LocalShippingIcon,
  Receipt as ReceiptIcon,
  Report as ReportIcon,
  Restore as RestoreIcon,
  Assignment as AssignmentIcon,
  NotificationsActive as NotificationsActiveIcon,
} from "@mui/icons-material";

export default function MenuContent() {
  const location = useLocation();
  const [activeSection, setActiveSection] = React.useState(null);

  const handleToggle = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };

  const isActive = (path) => location.pathname === path;

  return (
    <List
      dense
      sx={{
        "& .MuiListItemButton-root": {
          borderRadius: "12px",
          marginY: "4px",
          transition: "all 0.3s ease",
        },
        "& .MuiListItemButton-root:hover": {
          backgroundColor: "#f0f4ff",
          transform: "translateX(5px)",
        },
        "& .Mui-selected": {
          backgroundColor: "#7d7ddaff !important",
          color: "white",

        },
        "& .Mui-selected .MuiListItemIcon-root": {
          color: "white",
        },
      }}
    >
      {/* Home */}
      <ListItemButton
        component={Link}
        to="/dashboard"
        selected={isActive("/dashboard")}
      >
        <ListItemIcon sx={{ color: "#1976d2", minWidth: 40 }}>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText primary="Home" />
      </ListItemButton>

      {/* Staff */}
      <ListItemButton
        component={Link}
        to="/dashboard/stafflist"
        selected={isActive("/dashboard/stafflist")}
      >
        <ListItemIcon sx={{ color: "#e91e63", minWidth: 40 }}>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Staff" />
      </ListItemButton>

      {/* Branch */}
      <ListItemButton
        component={Link}
        to="/dashboard/branchlist"
        selected={isActive("/dashboard/branchlist")}
      >
        <ListItemIcon sx={{ color: "#ff9800", minWidth: 40 }}>
          <StoreIcon />
        </ListItemIcon>
        <ListItemText primary="Branch" />
      </ListItemButton>

      {/* Party */}
      <ListItemButton
        component={Link}
        to="/dashboard/partylist"
        selected={isActive("/dashboard/partylist")}
      >
        <ListItemIcon sx={{ color: "#9c27b0", minWidth: 40 }}>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Party" />
      </ListItemButton>

      {/* Freight */}
      <ListItemButton onClick={() => handleToggle("freight")}>
        <ListItemIcon sx={{ color: "#009688", minWidth: 40 }}>
          <LocalShippingIcon />
        </ListItemIcon>
        <ListItemText primary="Freight" />
        {activeSection === "freight" ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={activeSection === "freight"} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            component={Link}
            to="/dashboard/freight-form"
            selected={isActive("/dashboard/freight-form")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Freight Entry" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/freight-list"
            selected={isActive("/dashboard/freight-list")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Freight List" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/freightinvoice"
            selected={isActive("/dashboard/freightinvoice")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Due Freights" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/not-received-freight"
            selected={isActive("/dashboard/not-received-freight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Not Rec Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/freightpayment"
            selected={isActive("/dashboard/freightpayment")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Freight Pay" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton
        component={Link}
        to="/dashboard/tds-declarations"
        selected={isActive("/dashboard/tds-declarations")}
      >
        <ListItemIcon sx={{ color: "#9c27b0", minWidth: 40 }}>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Tds Declaration" />
      </ListItemButton>

      {/* Bill */}
      <ListItemButton onClick={() => handleToggle("bill")}>
        <ListItemIcon sx={{ color: "#3f51b5", minWidth: 40 }}>
          <ReceiptIcon />
        </ListItemIcon>
        <ListItemText primary="Bill" />
        {activeSection === "bill" ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={activeSection === "bill"} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            component={Link}
            to="/dashboard/bill-creation"
            selected={isActive("/dashboard/bill-creation")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Bill Creation" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/bill-list"
            selected={isActive("/dashboard/bill-list")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Bill List" />
          </ListItemButton>
        </List>
      </Collapse>

      {/* Issue */}
      <ListItemButton
        component={Link}
        to="/dashboard/issue-list"
        selected={isActive("/dashboard/issue-list")}
      >
        <ListItemIcon sx={{ color: "#f44336", minWidth: 40 }}>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Issue" />
      </ListItemButton>

      {/* Issue Alerts */}
      <ListItemButton
        component={Link}
        to="/dashboard/issue-alerts"
        selected={isActive("/dashboard/issue-alerts")}
      >
        <ListItemIcon sx={{ color: "#ff9800", minWidth: 40 }}>
          <NotificationsActiveIcon />
        </ListItemIcon>
        <ListItemText primary="Issue Alerts" />
      </ListItemButton>

      {/* Freight Report */}
      <ListItemButton onClick={() => handleToggle("report")}>
        <ListItemIcon sx={{ color: "#00bcd4", minWidth: 30 }}>
          <ReportIcon />
        </ListItemIcon>
        <ListItemText primary="Freight Report" />
        {activeSection === "report" ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={activeSection === "report"} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            component={Link}
            to="/dashboard/Allfreight"
            selected={isActive("/dashboard/Allfreight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="All Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/freightfilter"
            selected={isActive("/dashboard/freightfilter")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Freight Filter" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/Billpendingfreight"
            selected={isActive("/dashboard/Billpendingfreight")}
            sx={{ pl: 4 }}
          >
            <ListItemText primary="Bill Pending Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/Completefreight"
            selected={isActive("/dashboard/Completefreight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Complete Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/Partyfreight"
            selected={isActive("/dashboard/Partyfreight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Party Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/Vehiclefreight"
            selected={isActive("/dashboard/Vehiclefreight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Truck Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/Branchfreight"
            selected={isActive("/dashboard/Branchfreight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Branch Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/freight/payment/report"
            selected={isActive("/dashboard/freight/payment/report")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="All Freight Pay" />
          </ListItemButton>
        </List>
      </Collapse>

      {/* Bill Report */}
      <ListItemButton onClick={() => handleToggle("bill report")}>
        <ListItemIcon sx={{ color: "#673ab7", minWidth: 40 }}>
          <ReportIcon />
        </ListItemIcon>
        <ListItemText primary="Bill Report" />
        {activeSection === "bill report" ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={activeSection === "bill report"} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            component={Link}
            to="/dashboard/Allbills"
            selected={isActive("/dashboard/Allbills")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="All Bills" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/Completebill"
            selected={isActive("/dashboard/Completebill")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Complete Bills" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/pendingforbill"
            selected={isActive("/dashboard/pendingforbill")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Pending Bills" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/partyBill"
            selected={isActive("/dashboard/partyBill")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Party Bills" />
          </ListItemButton>
        </List>
      </Collapse>

      {/* Restore */}
      <ListItemButton onClick={() => handleToggle("Restore")}>
        <ListItemIcon sx={{ color: "#4caf50", minWidth: 40 }}>
          <RestoreIcon />
        </ListItemIcon>
        <ListItemText primary="Restore" />
        {activeSection === "Restore" ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={activeSection === "Restore"} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            component={Link}
            to="/dashboard/restore/staff"
            selected={isActive("/dashboard/restore/staff")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Staff" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/restore/branch"
            selected={isActive("/dashboard/restore/branch")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Branch" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/restore/party"
            selected={isActive("/dashboard/restore/party")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Party" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/restore/freight"
            selected={isActive("/dashboard/restore/freight")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Freight" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/dashboard/restore/bill"
            selected={isActive("/dashboard/restore/bill")}
            sx={{ pl: 6 }}
          >
            <ListItemText primary="Bill" />
          </ListItemButton>
        </List>
      </Collapse>
    </List>
  );
}
